<template>
  <v-card tile :loading="loading">
    <v-card-title>
      <p class="pt-5 pl-5">
        <v-row
          ><v-img
            class="pl-5"
            src="/icons/amende.png"
            :aspect-ratio="1"
            width="40"
          />{{ $t("main-nav.last_aos") }}
          <v-btn icon @click="refresh">
            <v-icon class="text--secondary">mdi-refresh</v-icon>
          </v-btn></v-row
        >
      </p>
    </v-card-title>

    <v-row no-gutters class="pa-2">
      <v-col cols="12" class="text--primary">
        <v-row no-gutter>
          <v-col cols="3">
            {{ $tc("common.date", 1) }}
          </v-col>
          <v-col cols="3">
            <p class="text-left">
              {{ $tc("ao.count_type_short", 1) }}
            </p>
          </v-col>
          <v-col cols="3" class="text-left">
            {{ $tc("ao.count_done_short", 1) }}
          </v-col>
          <v-col cols="3">
            <p class="text-left">
              {{ $tc("common.pef_short", 1) }}
            </p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-expansion-panels accordion v-if="items.length > 0">
      <v-expansion-panel v-for="(item, index) in items" :key="index">
        <v-expansion-panel-header>
          <v-row no-gutters>
            <v-col cols="12" class="text--secondary">
              <v-fade-transition leave-absolute>
                <v-row no-gutters>
                  <v-col cols="3">
                    {{ item.date | date }}
                  </v-col>
                  <v-col cols="3">
                    {{ item.count_types }}
                  </v-col>
                  <v-col cols="3">
                    {{ item.count_done }}
                  </v-col>
                  <v-col cols="3">
                    <User :user="item.user" link />
                  </v-col>
                </v-row>
              </v-fade-transition>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <ao :ao="item" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <div class="pa-5" v-else>{{ $t("feedback.empty") }}</div>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex"

import { FETCH } from "@/store/action-types"
import User from "@/components/card/User"
import LastTableMixin from "@/mixins/LastTableMixin"
import Ao from "@/components/item/Ao"

const { mapActions } = createNamespacedHelpers("ao")

export default {
  name: "LastAos",
  mixins: [LastTableMixin],
  components: { Ao, User },
  computed: {
    items() {
      return this.$store.state.ao.data
    },
  },

  methods: {
    ...mapActions([FETCH]),
  },
}
</script>
